import { ALL_POST, PIN_POST, DELETE_POST, PRE_PIN_POST, PRE_DELETE_POST, CERT_PIN_POST, CERT_DELETE_POST } from "../constants";

const initialState = [];

export const postReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ALL_POST: {
            state = [...payload];
            return state
        }
        case PIN_POST: {
            let temp = [...state];
            const { id, type } = payload;
            const index = state?.findIndex(data => data.id === id);
            if (index > -1) {
                if (type === "pin") {
                    temp[index].pin = true;
                } else {
                    temp[index].pin = false;
                }
            }
            return temp
        }
        case PRE_PIN_POST: {
            let temp = [...state];
            const { id, type } = payload;
            
            const index = state?.findIndex(data => data.id === id);
            if (index > -1) {
                if (type === "pin") {
                    temp[index].pin = true;
                } else {
                    temp[index].pin = false;
                }
            }
            return temp
        }
        case CERT_PIN_POST: {
            let temp = [...state];
            const { id, type } = payload;
            
            const index = state?.findIndex(data => data.id === id);
            if (index > -1) {
                if (type === "pin") {
                    temp[index].pin = true;
                } else {
                    temp[index].pin = false;
                }
            }
            return temp
        }
        case DELETE_POST: {
            let temp = [...state];
            temp = temp.filter(_ => _.id !== payload);
            return temp
        }
        case PRE_DELETE_POST: {
            let temp = [...state];
            temp = temp.filter(_ => _.id !== payload);
            return temp
        }
        case CERT_DELETE_POST: {
            let temp = [...state];
            temp = temp.filter(_ => _.id !== payload);
            return temp
        }
        default: {
            return state
        }
    }
};